import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-32 text-center">
      <div className="overline">404</div>
      <h1 className="font-display text-6xl mt-3">Page not found.</h1>
      <p className="text-[var(--fm-text-2)] mt-4">The page you're looking for doesn't exist.</p>
      <Link to="/" className="fm-btn-primary mt-8 inline-block">Back to home</Link>
    </div>
  );
}
